export default __webpack_public_path__ + "static/media/existing-experience.bee8d30c.jpg";